<template>
  <div class="indexPage">
    <div class="list">
      <div class="item" v-if="dataItem != ''">
        <div class="block_one">
          <div class="column flex-rowl">
            <p class="label">创建时间：</p>
            <p class="con red">{{ dataItem.createdate }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单号：</p>
            <p class="con">{{ dataItem.order_id }}</p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">取件地址：</p>
            <p class="con">{{ dataItem.getyuanqu }}{{ dataItem.get_parameteridstr }}{{ dataItem.get_buildingidstr }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取件人信息：</p>
            <p class="con">{{ dataItem.get_truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取件人手机号：</p>
            <p class="con">{{ dataItem.getlinkphone }}</p>
          </div>
        </div>

         <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">送件地址：</p>
            <p class="con">{{ dataItem.takeyuanqu }}{{ dataItem.take_parameteridstr }}{{ dataItem.take_buildingidstr }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送件人信息：</p>
            <p class="con">{{ dataItem.give_truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送件人手机号：</p>
            <p class="con">{{ dataItem.givelinkphone }}</p>
          </div>
        </div>
        
        <!-- <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">取件地址：</p>
            <p class="con">{{ dataItem.getyuanqu }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">取件人信息：</p>
            <p class="con">{{ dataItem.get_truename }}</p>
          </div>
        </div> -->

        <!-- <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">送件地址：</p>
            <p class="con">{{ dataItem.takeyuanqu }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送件人信息：</p>
            <p class="con">{{ dataItem.give_truename }}</p>
          </div>
        </div> -->

        <div class="block_two">
          <div class="column">
            <p class="label tit">物件信息</p>
            <p class="label">重量：{{ dataItem.weight }}</p>
          </div>
          <div class="column column_img flex-rowl">
            <div
              class="cloumn_item"
              v-for="(item, index) in dataItem.givepicArr"
              :key="index"
              @click="handlePreview(index)"
            >
              <van-image width="100%" height="100" :src="item" />
            </div>
          </div>
        </div>
        
        <div class="block_two">
          <div class="column flex-rowl" v-if="dataItem.distri_status == 1">
            <p class="label">跑腿业务员：</p>
            <p class="con red">{{ getInfo.get_staff_name }}</p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">订单情况：</p>
            <p class="con red">{{ dataItem.order_talkstr }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单状态：</p>
            <p class="con red">{{ dataItem.order_statusstr }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">服务进度：</p>
            <p class="con red">{{ dataItem.server_statestr }}</p>
          </div>
        </div>

        <div class="block_two" v-if="dataItem.msg_iserr == 1">
          <div class="column">
            <p class="label tit">订单信息是否异常：</p>
            <p class="con">{{ dataItem.msg_iserrstr }}</p>
          </div>
          <div class="column">
            <p class="label tit">订单异常类型：</p>
            <p class="con">{{ dataItem.errtypestr }}</p>
          </div>
          <div class="column" v-if="dataItem.errtype == 1">
            <p class="label tit">实际重量评估为：</p>
            <p class="con">{{ dataItem.realweight }}</p>
          </div>
          <div class="column" v-if="dataItem.errtype == 2">
            <p class="label tit">订单异常差额核算：</p>
            <p class="con">{{ dataItem.diff_num }}</p>
          </div>
          <div class="column" v-if="dataItem.errtype == 3">
            <p class="label tit">物品种类不符情况：</p>
            <p class="con">{{ dataItem.kinddiffstr }}</p>
          </div>
          <div class="column_btn_group flex-rowc">
            <div class="custom_btn" @click="handleToast">申请用户补支付</div>
            <div class="custom_btn" :class="{disabled: dataItem.order_status >= 6 || dataItem.order_talk >= 5}" @click="handleStatus(1)">取消订单</div>
          </div>
        </div>

        <!-- <template v-if="dataItem.has_complaint == '是'">
          <div class="block_two">
            <div class="column">
              <p class="label tit">投诉情况：</p>
              <p class="con">{{ dataItem.complaint_statusstr }}</p>
            </div>
            <div class="column">
              <p class="label tit">投诉原因：</p>
              <p class="con">{{ dataItem.complaint_reason }}</p>
            </div>
            <div class="column">
              <p class="label tit">投诉备注：</p>
              <p class="con">{{ dataItem.complaint_reason_note }}</p>
            </div>
            <div class="column">
              <p class="label tit">投诉处理办法：</p>
              <p class="con">{{ dataItem.complaint_deal }}</p>
            </div>
            <div class="column_btn_group flex-rowc">
              <div class="custom_btn isDisabled">已发送客户确认</div>
            </div>
          </div>

          <div class="block_two">
            <div class="column">
              <p class="label tit">投诉处理办法客户确认情况：</p>
              <p class="con">{{ getInfo.complaint_talkstr }}</p>
            </div>
          </div>
        </template> -->

        <div class="block_three" v-if="dataItem.has_complaint == '是'">
          <div class="column">
            <p class="label tit">投诉情况：</p>
            <p class="con">{{ dataItem.complaint_statusstr }}</p>
          </div>
          <div class="column">
            <p class="label tit">投诉原因：</p>
            <p class="con">
              {{dataItem.complaint_reasonstr}}
            </p>
            <!-- disabled -->
            <!-- <div class="radio_wrap">
              <van-radio-group v-model="dataItem.complaint_reasonstr">
                <van-radio
                  v-for="(item, index) in complaint_reason"
                  :key="index"
                  :name="item"
                  >{{ item }}</van-radio
                >
              </van-radio-group>
            </div> -->
          </div>
          <div class="column">
            <p class="label tit">投诉备注：</p>
            <p class="con">{{ dataItem.complaint_reason_note }}</p>
          </div>
          <div class="column">
            <p class="label tit">投诉处理办法：</p>
            <div class="textarea_box">
              <van-field v-model="complainParams.complaint_deal" type="textarea"></van-field>
            </div>
          </div>
          <div class="column_btn_group flex-rowc">
            <div class="custom_btn" :class="{disabled : dataItem.complaint_dealstatus == 1 && dataItem.complaint_talk !='用户不满意'}"  @click="handleStatus(2)">{{dataItem.complaint_dealstatus == 1 && dataItem.complaint_talk =='用户不满意' ? '重新发送客户确认' : (dataItem.complaint_dealstatus == 1 ? '已发送客户确认' : '发给客户确认')}}</div>
          </div>
            <!-- <div class="custom_btn" :class="{disabled : dataItem.complaint_dealstatus == 1 && dataItem.complaint_talk !='用户不满意'}"  @click="handleStatus(2)">{{dataItem.complaint_dealstatus == 1 && dataItem.complaint_talk !='用户不满意' ? '已发送客户确认' : '发给客户确认'}}</div>
          </div> -->
          <div class="column">
            <p class="label tit">投诉处理办法客户确认情况： </p>
            <p class="con">{{ dataItem.complaint_talk }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="custom_btn" @click="handleReturn">返回</div>

    <van-image-preview
      v-model="isImggeShow"
      :images="dataItem.givepicArr"
      :startPosition="startPosition"
    >
    </van-image-preview>
  </div>
</template>
  
<script>
import { getParkOrderDetail, cancelAbnormal, submitComplaint, getToken } from "../../api/api";
export default {
  name: "pDetailManag",
  data() {
    return {
      isImggeShow: false,
      startPosition: 0,
      isShow: false,
      popupSrc: "",
      isLoading: true,
      userInfo: "", // 用户信息
      dataItem: "", // 订单信息
      order_id: "", // 订单id
      token: "", // token

      // 订单分配人员信息
      distriInfo: {},
      // 跑腿业务信息
      getInfo: {},
      // 投诉原因
      complaint_reason: [
        "接送件等待时间过长",
        "长时间无人接单",
        "跑腿人员态度较差",
        "物品损坏",
        "其他",
      ],
      // 投诉参数
      complainParams: {
        token: "",
        order_id: "",
        complaint_deal: "",
      },
    };
  },
  created() {
    let { id } = this.$route.params;
    this.order_id = id;
    // this.token = this.$store.state.Authorization;
    this.userInfo = this.$store.state.USERINFO;
    this.getToken();
  },
  methods: {
    // 获取token
    getToken(type) {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.token = res.data.token;
          if (type == "cancelAbnormal") {
            this.cancelAbnormal();
          }else if(type == 'submitComplaint') {
            this.submitComplaint()
          } else {
            this.getParkOrderDetail(res.data.token);
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 查看跑腿订单详情
    getParkOrderDetail(token) {
      let { order_id } = this;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getParkOrderDetail({ order_id, token }).then((res) => {
        this.dataItem = res;
        // 订单分配人员信息
        res.delivery_list.forEach((v) => {
          if (v.isdel == 0) {
            this.distriInfo = v;
            this.deliveryStaffOpenid = v.delivery_staff_id;
          } else {
            this.distriInfo = {};
            this.deliveryStaffOpenid = "";
          }
        });
        // 跑腿业务信息
        res.get_list.forEach((v) => {
          if (v.isdel == 0) {
            this.getInfo = v;
          } else {
            this.getInfo = {};
          }
        });
        res.givepicArr = res.givepic ? res.givepic.split(",") : [];
        this.complainParams.complaint_deal = res.complaint_deal
        this.isLoading = false;
        toast.clear();
      });
    },
    // 取消订单
    cancelAbnormal() {
      let { order_id, token } = this;
      let params = {
        token,
        order_id,
        order_talk: 6 // 订单情况 =1=进行中 2=投诉处理中 3=投诉已处理 4=已完成 5=已取消(用户自主取消) 6=因投诉取消(客服取消)
      };
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      cancelAbnormal(params).then((res) => {
        if (res.error_code == 0) {
          this.$toast.success(res.message);
          this.getParkOrderDetail(token);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 业务员回复投诉
    submitComplaint() {
      let {order_id, token} = this
      this.complainParams.order_id = order_id
      this.complainParams.token = token
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      submitComplaint(this.complainParams).then(res => {
        if (res.error_code == 0) {
          this.$toast.success(res.message);
          this.getParkOrderDetail(token);
        } else {
          this.$toast.fail(res.message);
        }
      })
    },

    // 取消订单
    handleStatus(type) {
      let { dataItem, complainParams } = this;
      if (type == 1) {
        if (dataItem.order_talk >= 5 || dataItem.order_status >= 6) return;
        this.$dialog
          .confirm({
            // title: "标题",
            message: "是否取消",
          })
          .then(() => {
            // on confirm
            this.getToken("cancelAbnormal");
          })
          .catch(() => {
            // on cancel
          });
      }else if(type == 2){
        if(dataItem.complaint_dealstatus == 1 && dataItem.complaint_talk !='用户不满意') return
        if(complainParams.complaint_deal == '') {
          this.$toast('请输入投诉处理办法')
          return
        }
        this.getToken('submitComplaint')
      }
    },

    // 申请
    handleToast() {
      this.$toast("即将开放");
    },

    handleReturn() {
      this.$router.back();
    },

    // 预览图片
    handlePreview(index) {
      this.isImggeShow = true;
      this.startPosition = index;
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding: 40px 0 300px;
  .list {
    .item {
      width: 660px;
      min-height: 700px;
      background: #ffffff;
      border: 6px solid #e6e6e6;
      border-radius: 40px;
      margin: 0 auto 30px;
      padding: 52px 44px 0;
      box-sizing: border-box;
      font-size: 28px;
      color: #040000;
      .con {
        &.red {
          color: #ff0000;
        }
      }
      .block_one {
        font-size: 30px;
        margin-bottom: 65px;
        .column {
          .label {
            width: 140px;
          }
        }
      }
      .block_two {
        margin-bottom: 65px;
      }
      .block_three {
        margin-bottom: 70px;
        .column {
          &:nth-child(2) {
            margin: 40px 0;
          }
        }
        .column_btn_group {
          margin: 60px auto 90px;
        }
      }
      .column_img {
        flex-wrap: wrap;
        .cloumn_item {
          width: calc((100% - 60px) / 3);
          &:nth-child(3n-1) {
            margin: 0 30px;
          }
        }
      }
      .btn {
        margin-bottom: 60px;
      }
      .column {
        align-items: flex-start;
        &:nth-child(2n) {
          margin: 26px 0;
        }
        .label {
          white-space: nowrap;
          width: 190px;
          flex-shrink: 0;
          &.tit {
            margin-bottom: 15px;
          }
        }
        .con {
          word-wrap: break-word;
          flex-shrink: 0;
          width: 380px;
        }
        .select_box {
          margin-top: 20px;
          width: 100%;
          flex-shrink: 0;
          p {
            flex: 1;
          }
          .iconfont {
            font-size: 38px;
          }
        }
      }
      .column_btn_group {
        margin-top: 30px;
        .custom_btn {
          width: 240px;
          &.disabled {
                background: #9e9e9e;
              }
        }
      }
    }
  }
  .textarea_box {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    .van-cell {
      height: 100%;
    }
  }
  .custom_btn {
    &.isDisabled {
      background: #979797;
    }
  }
  .van-radio {
    margin-bottom: 10px;
  }
}
</style>